import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { throwError } from 'rxjs';
import { CommonService } from '../common_services/common.service';

@Injectable({
  providedIn: 'root'
})
export class BaseapiService {

  message: string[];

  constructor(
    private http: HttpClient,
    private commonService: CommonService,
  ) { }

  httpOptions = {
    headers: new HttpHeaders({
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + this.commonService.getLocalStorageByKey('token', 'access_token'),
      RefreshToken: this.commonService.getLocalStorageByKey('token', 'refresh_token')
    })
  };

  Get<T>(uri: string, param: any) {
    this.refreshHeader();
    return this.http.get(`${uri}`, { params: param, headers: this.httpOptions.headers }).map((response: T) => {
      return response;
    }).catch(this.handleError);
  }

  GetById<T>(uri: string, param: any) {
    this.refreshHeader();
    return this.http.get(`${uri}/${param}`, { headers: this.httpOptions.headers }).map((response: T) => {
      return response;
    }).catch(this.handleError);
  }
  

  GetAll<T>(uri: string) {
    this.refreshHeader();
    return this.http.get(`${uri}`, { headers: this.httpOptions.headers }).map((response: T) => {
      return response;
    }).catch(this.handleError);
  }

  Post<T>(uri: string, params: any, isReturn: boolean = false) {
    this.refreshHeader();
    return this.http.post(uri, params, this.httpOptions).map((response: T) => {
      return response;
    }).catch(this.handleError);
  }

  Put<T>(uri: string, params: any, id?: any, isReturn: boolean = false) {
    this.refreshHeader();
    return this.http.put(`${uri}`, params, this.httpOptions).map((response: T) => {
      return response;
    }).catch(this.handleError);
  }

  Delete<T>(uri: string, params: any, isReturn: boolean = false) {
    this.refreshHeader();
    return this.http.delete(`${uri}/${params}`, this.httpOptions).map((response: T) => {
      return response;
    }).catch(this.handleError);
  }

  private refreshHeader() {
    this.httpOptions = null;
    this.httpOptions = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + this.commonService.getLocalStorageByKey('token', 'access_token'),
       
      })
    };
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('An error occurred:', error.error.message);
    } else {
      console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}` + error.error.message);
    }
    this.message = [String(error.status), error.error.message];
    return throwError(this.message);
  }

}
